/**
 * @file Vuexstore to manage the alert shown inside the post composer modal
 * The idea behind this is similar to the confirmation_dialog module but we cannot just reuse it since both of the dialogs may appear together
 */

import { DispatchableAction } from 'types'
import { Module } from 'vuex'

interface ComposerModalAlertData {
  title: string
  body: string
  primaryActionText: string
  secondaryActionText: string
  primaryActions: DispatchableAction[]
  secondaryActions: DispatchableAction[]
}

interface ComposerModalAlertState extends ComposerModalAlertData {
  isOpen: boolean
}

const initialState = (): ComposerModalAlertState => ({
  isOpen: false,
  title: '',
  body: '',
  primaryActionText: '',
  secondaryActionText: '',
  primaryActions: [],
  secondaryActions: [],
})

const ComposerModalAlertModule: Module<ComposerModalAlertState, object> = {
  namespaced: true,
  state: initialState,
  getters: {
    isOpen: (state): boolean => state.isOpen,
  },
  mutations: {
    RESET_ALERT(state): void {
      Object.assign(state, initialState())
    },
    OPEN_ALERT(state, alertData: ComposerModalAlertData): void {
      Object.assign(state, alertData)
      state.isOpen = true
    },
  },
  actions: {
    openAlert({ commit }, params: ComposerModalAlertData): void {
      commit('OPEN_ALERT', params)
    },
    resetAlert({ commit }): void {
      commit('RESET_ALERT')
    },
    executePrimaryActions({ dispatch, state }): void {
      state.primaryActions.forEach((actionHash): void => {
        dispatch(actionHash.type, actionHash.payload, { root: true })
      })
      dispatch('resetAlert')
    },
    executeSecondaryActions({ dispatch, state }): void {
      state.secondaryActions.forEach((actionHash): void => {
        dispatch(actionHash.type, actionHash.payload, { root: true })
      })
      dispatch('resetAlert')
    },
  },
}

export default ComposerModalAlertModule
export { ComposerModalAlertData, ComposerModalAlertState }
